import React, { useEffect, useState, useRef } from "react";
import star from "../../../assets/elements/popular_icon.png";
import PopularDestinationServices from "../../../Services/PopularDestinationServices";
import "../../../scss/flag-sprite.css";
import RegionService from "../../../Services/RegionService";
import MicroLoader from "../../Alert_Popup/MicroLoader";
import PlansTray from "./PlansTray";

const LocalESim = ({
  vendorId,
  setRecurringModal,
  recurringModal,
  setModalData,
  setCurrentDetails,
  setDetailsOpen,
  suggestion,
  setSubPlan,
  subPlan,
  setShoweKycPopup,
  isTopPlan,
  resetTheFilterValue,
  setResetTheFilterValue
}) => {
  const [popularDestination, setPopularDestination] = useState([]);
  const [allPlans, setAllPlans] = useState([]);
  const [showPlansTray, setShowPlansTray] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [message, setMessage] = useState();
  const [statusCode, setStatusCode] = useState();
  const PopularDestinationListApi = () => {
    PopularDestinationServices.popularDestinationList().then((response) => {
      setPopularDestination(response.data);
    }).catch((error) => {
      if (error.message === "Network Error") {
        // setIsLoading(false);
        setMessage("Something went wrong, Please try again later");
      } else {
        setMessage(error.response.data.failedReason);
        setStatusCode(error.response ? error.response.status : "");
      }
    }
    );
  };

  const getAllPlans = () => {
    RegionService.countryList().then((response) => {
      setAllPlans(response.data);
    });
  };

  useEffect(() => {
    PopularDestinationListApi();
    getAllPlans();
  }, []);

  const handleAlphabetScroll = (letter) => {
    const countryElements = document.querySelectorAll(
      `.popular-destination-grid [data-letter="${letter}"]`
    );
    if (countryElements.length > 0) {
      const firstCountryElement = countryElements[0];
      const grid = firstCountryElement.closest(".popular-destination-grid");
      grid.scrollTo({
        top: firstCountryElement.offsetTop - grid.offsetTop,
        behavior: "smooth",
      });
    }
  };
  useEffect(() => {
    if (suggestion) {
      if (allPlans.length > 0) {
        const selectedCountry = allPlans?.find(
          (item) => item.alpha2 == suggestion
        );
        setSelectedCountry(selectedCountry);
        setShowPlansTray(true);
      }
    }
  }, [suggestion, allPlans]);
  return (
    <>
      {!showPlansTray ? (
        <>
          {popularDestination.length > 0 && allPlans.length > 0 ? (
            <div className="local-esim-destination mt-4">
              {popularDestination.length > 0 && (
                <>
                  <div className="d-flex justify-content-center align-items-center mb-3">
                    <img className="mr-1" src={star} alt="Popular" />
                    <h3>Popular Destination</h3>
                  </div>
                  <div className="popular-destination-grid">
                    {popularDestination.map((item, index) => {
                      return (
                        <div
                          onClick={() => {
                            setShowPlansTray(true);
                            setSelectedCountry(item.country);
                          }}
                          key={index}
                          className="grid-card"
                        >
                          <div>
                            <span
                              className={`fflag fflag-${item.country.alpha2} ff-lg ff-round`}
                            ></span>
                          </div>
                          <div
                            className="grid-tray"
                            style={{ overflow: "hidden" }}
                          >
                            <p>{item.country.countryDescription}</p>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </>
              )}
              {allPlans.length > 0 && (
                <div className="mt-5 allplan-card p-3 position-relative">
                  <h3 className="text-center mb-3">All Countries</h3>
                  <div className="alphabet-scroll notranslate">
                    <ul>
                      {Array.from({ length: 26 }, (_, i) =>
                        String.fromCharCode(65 + i)
                      ).map((letter) => (
                        <li key={letter}>
                          <span onClick={() => handleAlphabetScroll(letter)}>
                            {letter}
                          </span>
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div
                    className="all-plan-destination-grid popular-destination-grid"
                    style={{ overflowY: "auto", maxHeight: "300px" }}
                  >
                    {allPlans.map((item, index) => (
                      <div
                        onClick={() => {
                          setShowPlansTray(true);
                          setSelectedCountry(item);
                        }}
                        key={index}
                        className="grid-card"
                        data-letter={item.countryDescription
                          .charAt(0)
                          .toUpperCase()}
                      >
                        <div>
                          <span
                            className={`fflag fflag-${item.alpha2} ff-lg ff-round`}
                          ></span>
                        </div>
                        <div
                          className="grid-tray"
                          style={{ overflow: "hidden" }}
                        >
                          <p>{item.countryDescription}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{
                height: "250px",
              }}
            >
              <MicroLoader />
            </div>
          )}
        </>
      ) : (
        <PlansTray
          isTopPlan={isTopPlan}
          vendorId={vendorId}
          data={popularDestination}
          setShowPlansTray={setShowPlansTray}
          setRecurringModal={setRecurringModal}
          recurringModal={recurringModal}
          selected={selectedCountry}
          tab={"1"}
          setModalData={setModalData}
          setDetailsOpen={setDetailsOpen}
          setCurrentDetails={setCurrentDetails}
          setSubPlan={setSubPlan}
          subPlan={subPlan}
          setShoweKycPopup={setShoweKycPopup}
          resetTheFilterValue={resetTheFilterValue}
          setResetTheFilterValue={setResetTheFilterValue}
        />
      )}
    </>
  );
};

export default LocalESim;
